import { Record } from "immutable";
import moment from "moment";

const defaults = {
    brand_id: undefined,
    brand_name: undefined,
    created_at_ms: undefined,
    id: undefined,
    name: "",
    pages_ref: undefined,
    root_ref: undefined,
    // snapshot: undefined,
};

export class Board extends Record(defaults) {
    declare brand_id: string;
    declare brand_name: string;
    declare created_at_ms: moment.Moment;
    declare id: string;
    declare name: string;

    constructor(args) {
        super({
            ...args,
            created_at_ms: moment.utc(parseInt(args.created_at_ms, 10)),
        });
    }
}
